var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositionAtendimento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06519 20.016L5.43368 19.913C5.78812 19.8139 5.99515 19.4463 5.89611 19.0919L1.68308 4.01506C1.62363 3.80229 1.48209 3.62185 1.2896 3.51344C1.09711 3.40503 0.869431 3.37753 0.656663 3.43699L0.609075 3.45027C0.165981 3.57408 -0.0928588 4.03363 0.0309365 4.47673L4.24407 19.5535C4.34311 19.908 4.71074 20.115 5.06519 20.016V20.016Z",
    fill: "#30D158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9015 9.47993C18.5655 8.81375 17.3295 7.96343 16.2297 6.95384C16.1373 6.86921 16.1011 6.73931 16.1366 6.61909C16.6815 4.55756 17.0862 2.46149 17.3478 0.345263C17.3893 -0.00673446 17.1994 -0.110263 16.9993 0.131304C13.0721 4.82805 6.27718 -0.727984 2.23267 3.54084C2.28122 3.63176 2.31942 3.72784 2.34655 3.82727L5.0797 13.6142C9.13112 9.39711 15.9019 14.9186 19.8222 10.2322C20.0223 9.99068 20.0603 9.54895 19.9015 9.47993V9.47993Z",
    fill: "#30D158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionAtendimento);
export default __webpack_public_path__ + "static/media/position-atendimento.a1999d30.svg";
export { ForwardRef as ReactComponent };